const ADJECTIVES = [
  'Agile',
  'Bright',
  'Clever',
  'Daring',
  'Eager',
  'Fast',
  'Gleeful',
  'Happy',
  'Ideal',
  'Jazzy',
  'Kind',
  'Lucky',
  'Merry',
  'Narrow',
  'Ornate',
  'Practical',
  'Quirky',
  'Rapid',
  'Sharp',
  'Tangy',
  'Unique',
  'Vivid',
  'Witty',
  'Xenial',
  'Yellow',
  'Zesty',
]

const NOUNS = [
  'Apple',
  'Brick',
  'Cactus',
  'Diamond',
  'Eagle',
  'Forest',
  'Garage',
  'Horse',
  'Igloo',
  'Jungle',
  'Kite',
  'Lemon',
  'Mountain',
  'Nest',
  'Orchid',
  'Panda',
  'Quilt',
  'Rabbit',
  'Star',
  'Thimble',
  'Umbrella',
  'Vase',
  'Web',
  'Xray',
  'Yacht',
  'Zigzag',
]

function getSampleData() {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)]
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)]
  const number = Math.floor(Math.random() * 10000)
  return {
    firstName: adj,
    lastName: noun,
    email: `hi+${adj}-${noun}-${number}@with.co`.toLowerCase(),
    businessName: `${adj} ${noun} ${number} Inc.`,
  }
}

export { getSampleData }
